// extracted by mini-css-extract-plugin
export default {"container":"ip-z","brandName":"jp-z","productName":"kp-z","productNamePdpEnhancements":"lp-z","breakLongProductName":"mp-z"};